import type { PslfField as PslfFieldModel } from 'tio-data/data/resources/pslf-field.type';
import type { PslfTemplate } from './pslf-template.type.ts';

const personalInfoKeys = [
  'borrowerName',
  'borrowerBirthDate',
  'ssn',
  'borrowerEmail',
  'borrowerPrimaryPhone',
] as const;

const addressKeys = [
  'borrowerAddress',
  'borrowerApartment',
  'borrowerCity',
  'borrowerState',
  'borrowerZip',
] as const;

const employerFieldsKeys = [
  'borrowerPriorEmployerClosed',
  'borrowerWantsForbearance',
  'employerContactEmail',
  'employerFein',
  'employerName',
  'employerWebsite',
  'employmentStartDate',
  'employmentEndDate',
  'employmentHours',
  'employerContactName',
  'employerContactPhoneNumber',
  'employerContactTitle',
  // 'employmentContinues',
  // 'employmentFullTime',
  // 'employmentPartTime',
] as const;

interface BorrowerFormFields {
  personalInfo: PslfFieldModel[];
  address: PslfFieldModel[];
  employerFields: PslfFieldModel[];
}
export interface PslfTemplateExtension extends PslfTemplate {}
export class PslfTemplateExtension {
  get borrowerFormFields(): BorrowerFormFields {
    const fieldsByKey = new Map(this.pslfFields.map((f) => [f.key, f]));

    const orderBy = (keys: readonly string[]) =>
      keys.map((key) => fieldsByKey.get(key)).filter(Boolean) as PslfFieldModel[];

    return {
      personalInfo: orderBy(personalInfoKeys),
      address: orderBy(addressKeys),
      employerFields: orderBy(employerFieldsKeys),
    };
  }

  get pdfUrl() {
    return this.pslfAssets[0]?.signedUrl || '';
  }
}

const Registration = {
  kind: 'object',
  name: 'pslf-template',
  features: PslfTemplateExtension,
};
export default Registration;
